import { CalculadoraIRPH } from '../components/graphs/CalculadoraIRPH';

/**
 * Página pública e independiente de la Calculadora IRPH.
 *
 * Ruta: /calculadora-irph — Pensada como utilidad accesible por cualquiera.
 */
export const CalculadoraIRPHPublica = () => {
  document.title = 'Calculadora IRPH | Coventia Legal';

  return (
    <div className="min-h-screen w-full bg-gray-50 dark:bg-gray-900 p-3 lg:p-4">
      <CalculadoraIRPH />
    </div>
  );
};

export default CalculadoraIRPHPublica;
